export default {
    title: '首页'
}